function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M72.09.02L59.62 0c-14 0-23.05 9.29-23.05 23.66v10.9H24.04c-1.09 0-1.96.88-1.96 1.96v15.8c0 1.09.87 1.97 1.96 1.97h12.53v39.87c0 1.09.88 1.96 1.96 1.96h16.35c1.09 0 1.96-.88 1.96-1.96V54.3H71.5c1.08 0 1.96-.88 1.96-1.96v-15.8a1.96 1.96 0 00-1.96-1.97H56.84v-9.24c0-4.45 1.06-6.7 6.85-6.7h8.4c1.08 0 1.96-.88 1.96-1.97V1.98c0-1.08-.88-1.96-1.96-1.96z"
});
function SvgFacebook(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96.12 96.12",
    ref: svgRef
  }, props), _ref);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default ForwardRef;